import { colorsPalettes } from "@similarweb/styles";

export const GreenPalette = {
    background: colorsPalettes.green[100],
    label: colorsPalettes.green["s100"],
};
export const RedPalette = {
    background: colorsPalettes.red[100],
    label: colorsPalettes.red["s100"],
};
export const GrayPalette = {
    background: colorsPalettes.carbon[25],
    label: colorsPalettes.carbon[250],
};

